import { createReducer } from '../helpers';

const initialStateFactory = (botId, bot) => ({
    botId: botId || null,
    currentPath: [{ id: bot ? bot.botData.startResponseId : 1 }],
});

const initialState = initialStateFactory();

export default createReducer(initialState, {
    SELECT_BOT: (state, { botId, bot }) => {
        if (state.botId !== botId) {
            Object.assign(state, initialStateFactory(botId, bot));
        }
    },

    SET_DIALOG_PATH: (state, { path }) => {
        state.currentPath = path;
    },

    OPEN_DIALOG_BRANCH: (state, { parentResponseID, nextResponseID, content }) => {
        const constructedPath = [];

        for (const step of state.currentPath) {
            constructedPath.push(step);

            if (step.id === parentResponseID) {
                if (nextResponseID) {
                    constructedPath.push({
                        parentResponseID,
                        id: nextResponseID,
                        reaction: {
                            content: content,
                        },
                    });
                }

                break;
            }
        }

        state.currentPath = constructedPath;
    },
});
